import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    isNumero,
} from '../../../business-components/String/String'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    trataValorTexto,
    trataPercentualTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiPosicaoInvestimentos,
} from './IntegracaoClienteArquivoService'





const trataContaCorrente = (PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, contaCorrente) => {

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + contaCorrente, fimLinha,
        HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)
            
    if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

        const linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

        const valor = trataValorTexto(linhaDados[linhaDados.length - 1])
        
        if (valor !== 0) {

            incluiPosicaoInvestimentos(posicaoInvestimentos, HARDCODE.idTipoRecursoFinanceiroContaCorrente, contaCorrente,
                valor/*, percRentabilidadeAnualRecursoFinanceiro*/, jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                    null, null, null, null, null, null, null, null, null, null)
        }
    }
}

export const importaPosicaoInvestimentosBTG = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll('\u0000', 'a')
    PDFTxt = PDFTxt.replaceAll('Inf lação', 'Inflação')
    PDFTxt = PDFTxt.replaceAll('Pós-axado', 'Pós-fixado')
    PDFTxt = PDFTxt.replaceAll('Pós-fixado - Encerrados', 'Pós-fixado-Encerrados')
    PDFTxt = PDFTxt.replaceAll('Pré-axado', 'Pré-fixado')
    PDFTxt = PDFTxt.replaceAll('Renda Variável', 'Renda-Variável')
    PDFTxt = PDFTxt.replaceAll('Renda Fixa', 'Renda-Fixa')
    PDFTxt = PDFTxt.replaceAll('Alt ernat ivo', 'Alternativo')
    PDFTxt = PDFTxt.replaceAll('Ret orno Absolut o (MM)', 'Retorno-Absoluto-(MM)')
    PDFTxt = PDFTxt.replaceAll('Retorno-Absoluto-(MM) - Encerrados', 'Retorno-Absoluto-(MM)-Encerrados')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Ativo' + fimLinha + 'Saldo' + fimLinha + 'Bruto (R$)' + fimLinha +
        'Percentual' + fimLinha + '%' + fimLinha + 'Saldo' + fimLinha + 'bruto/PL %' + fimLinha +
            'Mês Ano 12 Meses Acumulada Data Inicial' + fimLinha,
                fimLinha + 'Ativo Saldo Bruto (R$) Percentual % Saldo bruto/PL % Mês Ano 12 Meses Acumulada Data Inicial' +
                    fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Ativo' + fimLinha + 'Saldo' + fimLinha + 'Bruto (R$)' + fimLinha +
        'Percentual' + fimLinha + '%' + fimLinha + 'Saldo' + fimLinha + 'bruto/PL %' + fimLinha +
            'Mês Ano' + fimLinha + '12' + fimLinha + 'Meses' + fimLinha + 'Acumulada Data Inicial Data Final' + fimLinha,
                fimLinha + 'Ativo Saldo Bruto (R$) Percentual % Saldo bruto/PL % Mês Ano 12 Meses Acumulada Data Inicial Data Final' +
                    fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Ativo' + fimLinha + 'Saldo' + fimLinha + 'Bruto (R$)' + fimLinha +
        'Percentual' + fimLinha + '%' + fimLinha + 'Saldo' + fimLinha + 'bruto/PL %' + fimLinha +
            'Mês Ano' + fimLinha + '12' + fimLinha + 'Meses' + fimLinha + 'Acumulada Data Inicial' + fimLinha,
                fimLinha + 'Ativo Saldo Bruto (R$) Percentual % Saldo bruto/PL % Mês Ano 12 Meses Acumulada Data Inicial' +
                    fimLinha)
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraBTG

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Conta Investimento' + espaco, fimLinha,
        HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)
    
    //////obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Patrimônio líquido' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    //////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade no mês foi de' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
    ////    HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Os principais números de cada Mercado e Estratégia' + fimLinha,
        fimLinha + 'A rentabilidade completa' + fimLinha, HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)

    let rentabilidadeAntes = false

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Os principais números de cada Mercado e Estratégia' + fimLinha,
            fimLinha + 'Disclaimer' + fimLinha, HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)
        
        if (jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

            rentabilidadeAntes = true
        }
    }

    let indexLinhasPosicaoInvestimentosATratarVencimento
    let linhasPosicaoInvestimentosVencimento

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

        const linhasPosicaoInvestimentosATratarVencimento =
            jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
        indexLinhasPosicaoInvestimentosATratarVencimento = 0

        linhasPosicaoInvestimentosVencimento = []

        let dadosPosicaoInvestimentosVencimento

        while (indexLinhasPosicaoInvestimentosATratarVencimento < linhasPosicaoInvestimentosATratarVencimento.length) {

            if (
                    pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                        linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].split(espaco)[0]).id
            ) {

                indexLinhasPosicaoInvestimentosATratarVencimento++

                dadosPosicaoInvestimentosVencimento = ''

                while (indexLinhasPosicaoInvestimentosATratarVencimento < linhasPosicaoInvestimentosATratarVencimento.length) {

                    if (
                            linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].substring(0, 24)
                                !== 'RELATÓRIO DE PERFORMANCE' &&
                            linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].substring(0, 10)
                                !== 'PERÍODO DE' &&
                            linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].substring(0, 7)
                                !== 'PÁGINA ' &&
                            linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento]
                                !== 'ATIVO DATA INICIAL QUANTIDADE RESGATE SALDO BRUTO PREÇO MÉDIO SALDO LÍQUIDO VALOR  APLICADO' // &&
                            //linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento]
                            //    !== 'ATIVO SALDO BRUTO (R$) PERCENTUAL % SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA'
                    ) {

                        dadosPosicaoInvestimentosVencimento += (dadosPosicaoInvestimentosVencimento ? espaco : '') +
                            linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento]

                        if (
                                linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento]
                                    .indexOf('R$ ') !== -1 &&
                                linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].substring(0, 6) !==
                                    'TOTAL ' 
                        ) {
                            
                            linhasPosicaoInvestimentosVencimento.push(
                                dadosPosicaoInvestimentosVencimento
                            )

                            dadosPosicaoInvestimentosVencimento = ''

                            indexLinhasPosicaoInvestimentosATratarVencimento++

                            if (
                                    linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].substring(0, 6) ===
                                        'TOTAL ' ||
                                    pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                                        linhasPosicaoInvestimentosATratarVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].split(espaco)[0]).id
                            ) {

                                break
                            }

                        } else {

                            indexLinhasPosicaoInvestimentosATratarVencimento++
                        }

                    } else {

                        indexLinhasPosicaoInvestimentosATratarVencimento++
                    }
                } 

            } else {

                indexLinhasPosicaoInvestimentosATratarVencimento++
            }
        }
        //console.log(linhasPosicaoInvestimentosVencimento)
    }

    if (rentabilidadeAntes) {

        jsonRegistros.indexInicial = 0
    }
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade completa' + fimLinha,
        fimLinha + (rentabilidadeAntes ? 'Posição consolidada por devedor/garantidor' : 'Movimentações da conta') + fimLinha,
            HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade completa' + fimLinha,
            fimLinha + (rentabilidadeAntes ? 'Posição consolidada por devedor/garantidor' : 'Disclaimer') + fimLinha,
                HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)
    }

    let modelo =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.indexOf(fimLinha + '% DO CDI') !== -1
            ?
                1
            :
                jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.indexOf(fimLinha + 'CDI' + espaco) !== -1
                    ?
                        3
                    :
                        2
                
    const linhasPosicaoInvestimentosATratar =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentosATratar

    const linhasPosicaoInvestimentos = []
    let indexLinhasPosicaoInvestimentos

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro
    let dataInicioRecursoFinanceiro = null
    let percRentabilidadeMesRecursoFinanceiro
    let percCDIMesRecursoFinanceiro
    let percRentabilidadeAnoRecursoFinanceiro
    let percCDIAnoRecursoFinanceiro
    let percRentabilidade12MRecursoFinanceiro
    let percCDI12MRecursoFinanceiro
    let percRentabilidade24MRecursoFinanceiro
    let percCDI24MRecursoFinanceiro
    
    let vencimento = null

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentosATratar = 0

    while (indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length) {
        //console.log('--------' + indexLinhasPosicaoInvestimentosATratar)
        //console.log(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar])

        if (
                pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].split(espaco)[0]).id
        ) {

            linhasPosicaoInvestimentos.push(
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
            )

            indexLinhasPosicaoInvestimentosATratar++
            //console.log('entrou' + indexLinhasPosicaoInvestimentosATratar)

            dadosPosicaoInvestimentos = ''

            while (indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length) {
                //console.log(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar])

                if (
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 24)
                            !== 'RELATÓRIO DE PERFORMANCE' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 10)
                            !== 'PERÍODO DE' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 7)
                            !== 'PÁGINA ' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) PERCENTUAL % SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA DATA INICIAL' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) PERCENTUAL % SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA DATA INICIAL DATA FINAL' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) PERCENTUAL % SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) SALDO BRUTO/PL % MÊS ANO 12 MESES ACUMULADA DATA INICIAL' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 18) !==
                            'EM RENDA-VARIÁVEL ' //*****
                ) {

                    dadosPosicaoInvestimentos += (dadosPosicaoInvestimentos ? espaco : '') +
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]

                    if (
                            (
                                modelo === 1 &&
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 8) ===
                                    '% DO CDI'
                            ) ||
                            (
                                modelo === 2 &&
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(2, 3) ===
                                    '/' &&
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(5, 6) ===
                                    '/' 
                            ) ||
                            (
                                modelo === 2 &&
                                (
                                    (
                                        isNumero(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 1)) ||
                                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 1) === '-'
                                    ) &&
                                    !isNumero(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar + 1].substring(0, 1)) &&
                                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar + 1].substring(0, 1) !== '-'
                                )
                            ) ||
                            (
                                modelo === 3 &&
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 4) ===
                                    'CDI' + espaco
                            )
                    ) {
                        
                        linhasPosicaoInvestimentos.push(
                            dadosPosicaoInvestimentos
                        )

                        dadosPosicaoInvestimentos = ''

                        indexLinhasPosicaoInvestimentosATratar++

                        if (
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 6) ===
                                    'TOTAL ' ||
                                pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].split(espaco)[0]).id
                        ) {

                            break
                        }

                    } else {

                        indexLinhasPosicaoInvestimentosATratar++
                    }

                } else {

                    indexLinhasPosicaoInvestimentosATratar++

                     if (//*****
                            indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length &&
                            pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].split(espaco)[0]).id
                    ) {

                        break
                    }
                }
            } 

        } else {

            indexLinhasPosicaoInvestimentosATratar++
        }
    }
    //console.log(2)
    //console.log(linhasPosicaoInvestimentos)

    indexLinhasPosicaoInvestimentos = 0

    indexLinhasPosicaoInvestimentosATratarVencimento = 0
    //console.log(linhasPosicaoInvestimentos)

    let temDataFinal = false

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)[0]).idConversao

        if (tipoRecursoFinanceiroAux) {

            temDataFinal =
                linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)[0].indexOf('ENCERRADOS') !== -1

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            dadosPosicaoInvestimentos = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)

            let ajuste = 0

            if (linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('/') === -1) {

                ajuste = 1
            }

            let ajuste2 = 0

            if (modelo === 2) {

                ajuste2 = 12

            } else {

                 if (modelo === 3) {

                    ajuste2 = 8
                }
            }

            let ajuste3 = 0

            if (temDataFinal) {

                ajuste3 = - 1

            }

            posFinalDescricao = dadosPosicaoInvestimentos.length - 25 + ajuste + ajuste2 + ajuste3

            descricao = obtemTextoArray(dadosPosicaoInvestimentos, 0, posFinalDescricao) 

            valor = trataValorTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 24 + ajuste + ajuste2 + ajuste3])

            if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 24 + ajuste + ajuste2 + ajuste3].indexOf('-') !== -1) {

                valor = valor * -1
            }

            if (valor === 0) {

                valor = '0.00'
            }

            if (modelo === 3) {

                ajuste2--
            }

            dataInicioRecursoFinanceiro =
                ajuste
                    ?
                        ''
                    :
                        trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 13 + ajuste2 + ajuste3])
            percRentabilidadeMesRecursoFinanceiro =
                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 21 + ajuste + ajuste2 + ajuste3])
            percCDIMesRecursoFinanceiro =
                modelo === 2 || modelo === 3
                    ?
                        ''
                    :
                        trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 4])
            percRentabilidadeAnoRecursoFinanceiro =
                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 19 + ajuste + ajuste2 + ajuste3])
            percCDIAnoRecursoFinanceiro =
                modelo === 2 || modelo === 3
                    ?
                        ''
                    :
                        trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3 + ajuste2])
            percRentabilidade12MRecursoFinanceiro =
                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 17 + ajuste + ajuste2 + ajuste3])
            percCDI12MRecursoFinanceiro =
                modelo === 2 || modelo === 3
                    ?
                        ''
                    :
                        trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2 + ajuste2])
            
            vencimento = null

            if (linhasPosicaoInvestimentosVencimento) {

                const dadosVencimento =
                    linhasPosicaoInvestimentosVencimento[indexLinhasPosicaoInvestimentosATratarVencimento].split(espaco)

                let indexDadosVencimento = 0

                while (indexDadosVencimento < dadosVencimento.length) {

                    if (
                            dadosVencimento[indexDadosVencimento].substring(2, 3) === '/' &&
                            dadosVencimento[indexDadosVencimento].substring(5, 6) === '/'
                    ) {

                        if (
                                dadosVencimento[indexDadosVencimento + 2].substring(2, 3) === '/' &&
                                dadosVencimento[indexDadosVencimento + 2].substring(5, 6) === '/' &&
                                descricao.split(espaco)[0] === dadosVencimento[0]
                        ) {

                            vencimento = trataData(dadosVencimento[indexDadosVencimento + 2])
                        }
                    }

                    indexDadosVencimento++
                }
            }

            //Não deu certo
            //percRentabilidadeAnualRecursoFinanceiro =
            //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
            //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

            //Problema com conversão de taxas negativas
            //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

            //    percRentabilidadeAnualRecursoFinanceiro =
            //        converteTaxaMensalEmAnual(
            //            converteTaxaEmMensal(
            //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
            //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
            //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
            //                    )
            //            )
            //        )
            //}

            incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                valor/*, percRentabilidadeAnualRecursoFinanceiro*/, jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                    dataInicioRecursoFinanceiro, percRentabilidadeMesRecursoFinanceiro, percCDIMesRecursoFinanceiro,
                        percRentabilidadeAnoRecursoFinanceiro, percCDIAnoRecursoFinanceiro, percRentabilidade12MRecursoFinanceiro,
                            percCDI12MRecursoFinanceiro, percRentabilidade24MRecursoFinanceiro, percCDI24MRecursoFinanceiro, vencimento)

            indexLinhasPosicaoInvestimentosATratarVencimento++
        }

        indexLinhasPosicaoInvestimentos++
    }

    jsonRegistros.indexInicial = 0

    trataContaCorrente(PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, 'Valor em transito')
    
    trataContaCorrente(PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, 'Conta corrente')
    
   

    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos
    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
    console.log(jsonRegistros)
    */



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}



export const importaPosicaoInvestimentosBTGLayout2 = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll('\u0000', 'a')
    PDFTxt = PDFTxt.replaceAll('Inf lação', 'Inflação')
    PDFTxt = PDFTxt.replaceAll('Pós-axado', 'Pós-fixado')
    PDFTxt = PDFTxt.replaceAll('Pré-axado', 'Pré-fixado')
    PDFTxt = PDFTxt.replaceAll('Renda Variável', 'Renda-Variável')
    PDFTxt = PDFTxt.replaceAll('Renda Fixa', 'Renda-Fixa')
    PDFTxt = PDFTxt.replaceAll('Alt ernat ivo', 'Alternativo')
    PDFTxt = PDFTxt.replaceAll('Ret orno Absolut o (MM)', 'Retorno-Absoluto-(MM)')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Ativo' + fimLinha + 'Saldo' + fimLinha + 'Bruto (R$)' + fimLinha +
        'Saldo' + fimLinha + 'bruto/PL' + fimLinha + '%' + fimLinha + 'Mês 3 Meses 6 Meses Ano 12 Meses' + fimLinha +
            '24' + fimLinha + 'Meses' + fimLinha + '36' + fimLinha + 'Meses' + fimLinha + 'Acumulada Data Inicial' + fimLinha,
                fimLinha +
                    'Ativo Saldo Bruto (R$) Saldo bruto/PL % Mês 3 Meses 6 Meses Ano 12 Meses 24 Meses 36 Meses Acumulada Data Inicial' +
                        fimLinha)
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraBTG

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Conta Investimento' + espaco, fimLinha,
        HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)
    
    //////obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Patrimônio líquido' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    //////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade no mês foi de' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
    ////    HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade completa' + fimLinha,
        fimLinha + 'Disclaimer' + fimLinha, HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)

    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos)
                
    const linhasPosicaoInvestimentosATratar =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentosATratar

    const linhasPosicaoInvestimentos = []
    let indexLinhasPosicaoInvestimentos

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentosATratar = 0

    while (indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length) {
        //console.log('--------' + indexLinhasPosicaoInvestimentosATratar)
        //console.log(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar])

        if (
                pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].split(espaco)[0]).id
        ) {

            linhasPosicaoInvestimentos.push(
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
            )

            indexLinhasPosicaoInvestimentosATratar++
            //console.log('entrou' + indexLinhasPosicaoInvestimentosATratar)

            dadosPosicaoInvestimentos = ''

            while (indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length) {
                //console.log(linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar])

                if (
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 24)
                            !== 'RELATÓRIO DE PERFORMANCE' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 10)
                            !== 'PERÍODO DE' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 7)
                            !== 'PÁGINA ' &&
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                            !== 'ATIVO SALDO BRUTO (R$) SALDO BRUTO/PL % MÊS 3 MESES 6 MESES ANO 12 MESES 24 MESES 36 MESES ACUMULADA DATA INICIAL'
                ) {

                    dadosPosicaoInvestimentos += (dadosPosicaoInvestimentos ? espaco : '') +
                        linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]

                    if (
                            linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(2, 3) ===
                                '/' &&
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(5, 6) ===
                                    '/' 
                    ) {
                        
                        linhasPosicaoInvestimentos.push(
                            dadosPosicaoInvestimentos
                        )

                        dadosPosicaoInvestimentos = ''

                        indexLinhasPosicaoInvestimentosATratar++

                        if (
                                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 6) ===
                                    'TOTAL ' ||
                                pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
                                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].split(espaco)[0]).id
                        ) {

                            break
                        }

                    } else {

                        indexLinhasPosicaoInvestimentosATratar++
                    }

                } else {

                    indexLinhasPosicaoInvestimentosATratar++
                }
            } 

        } else {

            indexLinhasPosicaoInvestimentosATratar++
        }
    }
    //console.log(2)
    //console.log(linhasPosicaoInvestimentos)

    indexLinhasPosicaoInvestimentos = 0

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)[0]).idConversao

        if (tipoRecursoFinanceiroAux) {

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            dadosPosicaoInvestimentos = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)
            //console.log(dadosPosicaoInvestimentos)

            ////let ajuste = 0

            ////if (linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('/') === -1) {
                //console.log('vai ajustar')

            ////    ajuste = 1
            ////}

            posFinalDescricao = dadosPosicaoInvestimentos.length - 20/* + ajuste*/

            descricao = obtemTextoArray(dadosPosicaoInvestimentos, 0, posFinalDescricao) 

            valor = trataValorTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 19/* + ajuste*/])

            if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 19/* + ajuste*/].indexOf('-') !== -1) {

                valor = valor * -1
            }

            if (valor === 0) {

                valor = '0.00'
            }

            //Não deu certo
            //percRentabilidadeAnualRecursoFinanceiro =
            //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
            //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

            //Problema com conversão de taxas negativas
            //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

            //    percRentabilidadeAnualRecursoFinanceiro =
            //        converteTaxaMensalEmAnual(
            //            converteTaxaEmMensal(
            //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
            //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
            //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
            //                    )
            //            )
            //        )
            //}

            incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                valor/*, percRentabilidadeAnualRecursoFinanceiro*/, jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                    null, null, null, null, null, null, null, null, null, null)
        }

        indexLinhasPosicaoInvestimentos++
    }

   

    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos
    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
    console.log(jsonRegistros)
    */



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}